// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2bQfH","inputWrap":"Table_inputWrap__2hN6I","col":"Table_col__-52zJ","bmiTooltip":"Table_bmiTooltip__BfCgG"};